import { env } from "@/env";
import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  // Prázdné VITE_API_URL = same-origin → necháme Better-Auth použít current
  // origin (window.location.origin). Absolutní URL jen pro cross-origin dev.
  baseURL: env.VITE_API_URL || undefined,
});
